import { Divider } from "@mui/material";
import bannerConstruindoJornadas from "../../../../../assets/images/empresa/sobre-nos/SOBRE_NÓS_construindo-jornadas.png";
import imgCincoDecadasHistoria from "../../../../../assets/images/empresa/sobre-nos/maos-negocio-juntou-junto-trabalho-equipe.png";
import MidiaTextBanner from "../../../../../components/layout/midia-text-banner";
import DefaultText from "../../../../../components/typography/default-text";
import styles from "./styles.module.css";
import { sxDivider } from "./sxProps";
import { useMediaQuery } from "@mui/material";


const Identidade: React.FC = () => {

  const isMobile = useMediaQuery("(max-width: 899px)");

  const redirectExternalLink = (link: string) => {
    window.open(link, "_blank");
  }

  const descriptionDesktop = `
    Nossos colaboradores são guiados por valores que 
    direcionam suas ações, assegurando não apenas a 
    excelência no que fazem, mas também a 
    sustentabilidade do nosso negócio.
  `;

  const descriptionMobile = `
    Nossos colaboradores são guiados por 
    valores que direcionam suas ações,
    assegurando não apenas a excelência 
    no que fazem, mas também a 
    sustentabilidade do nosso negócio.
  `;

  const description = isMobile ? descriptionMobile : descriptionDesktop;

  return (
    <>
      <div className={styles["sub-page-content"]}>
        <div className={styles["nossos-valores-banner-container"]}>
          <img src={imgCincoDecadasHistoria} alt="Imagem de funcionário da Telemont subindo em uma escada" className={styles["banner-image"]} />
          <DefaultText size="small" maxWidth={"700px"}>
            A Telemont possui uma <span style={{ fontFamily: 'Montserrat-Bold'}}>identidade organizacional sólida</span>, construída ao longo de décadas de atuação com foco em pessoas, segurança, qualidade e resultado. Essa identidade reflete uma cultura que sustenta relações de confiança com clientes, parceiros e colaboradores. É essa base firme que orienta nossas decisões e garante a consistência da marca em todos os territórios onde atuamos.
          </DefaultText>
        </div>
        <div className={styles["objetivos-container"]}>
          <div className={styles["objetivos-divider"]}>
            <div className={styles["objetivos-content"]}>
              <div>
                <DefaultText sx={{ fontFamily: 'Montserrat-Bold', '@media (max-width: 899px)': {fontSize: '32px'}}}><i>Propósito</i></DefaultText>
              </div>
              <div>
                <DefaultText size="small">
                  Transformar vidas e impulsionar futuros.
                </DefaultText>
              </div>
            </div>
          </div>
          <div className={styles["objetivos-divider"]}>
            <Divider flexItem orientation='vertical' sx={{ ...sxDivider, '@media (max-width: 899px)': {display: 'none'}}}/>
            <div className={styles["objetivos-content"]}>
              <div>
                <DefaultText sx={{ fontFamily: 'Montserrat-Bold', '@media (max-width: 899px)': {fontSize: '32px'}}}><i>Missão</i></DefaultText>
              </div>
              <div>
                <DefaultText size="small">
                  Conectar pessoas e negócios através da tecnologia.
                </DefaultText>
              </div>
            </div>
          </div>
          <div className={styles["objetivos-divider"]}>
            <Divider flexItem orientation='vertical' sx={{ ...sxDivider, '@media (max-width: 899px)': {display: 'none'}}}/>
            <div className={styles["objetivos-content"]}>
              <div>
                <DefaultText sx={{ fontFamily: 'Montserrat-Bold', '@media (max-width: 899px)': {fontSize: '32px'}}}><i>Visão</i></DefaultText>
              </div>
              <div>
                <DefaultText size="small">
                  Ser a referência brasileira em soluções para infraestrutura de Telecom e Energia.
                </DefaultText>
              </div>
            </div>
          </div>
          <div className={styles["objetivos-divider"]}>
            <Divider flexItem orientation='vertical' sx={{ ...sxDivider, '@media (max-width: 899px)': {display: 'none'}}}/>
            <div className={styles["objetivos-content"]}>
              <div>
                <DefaultText sx={{ fontFamily: 'Montserrat-Bold', '@media (max-width: 899px)': {fontSize: '32px'}}}><i>Valores</i></DefaultText>
              </div>
              <div>
                <DefaultText size="small">
                  <span className={styles['list-item-mobile']}>&bull; Operar de modo seguro</span>
                  <span className={styles['list-item-mobile']}>&bull; Satisfação do cliente</span>
                  <span className={styles['list-item-mobile']}>&bull; Resultados sustentáveis</span>
                  <span className={styles['list-item-mobile']}>&bull; Excelência em gente</span>
                  <span className={styles['list-item-mobile']}>&bull; Respeito e simplicidade</span>
                  <span className={styles['list-item-mobile']}>&bull; Colaboração</span>
                </DefaultText>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles["sub-page-content-grey"]}>
        <MidiaTextBanner headingRegular="Construindo jornadas" headingBold="transformadoras"
          description={description}
          buttonText="Faça Parte" image={bannerConstruindoJornadas}
          onButtonClick={() => { redirectExternalLink('https://telemont.gupy.io/') }}
          applyNegativeMargin={true}
        />
      </div>
    </>
  );
};

export default Identidade;